import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const SIDEBAR_STORAGE_KEY = 'rabbit-sidebar-collapsed';

export const getStoredSidebarCollapsed = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    const stored = window.localStorage.getItem(SIDEBAR_STORAGE_KEY);
    if (stored === 'true') return true;
    if (stored === 'false') return false;
    return false; // default: sidebar open
  } catch {
    return false;
  }
};

export const setStoredSidebarCollapsed = (collapsed: boolean): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(SIDEBAR_STORAGE_KEY, String(collapsed));
  } catch {
    // Ignore storage errors
  }
};

interface PromptsStore {
  activeView: string;
  sidebarCollapsed: boolean;
  isSidebarInitialized: boolean;
  isUIVisible: boolean;
  setActiveView: (view: string) => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  setSidebarInitialized: (initialized: boolean) => void;
  toggleSidebar: () => void;
  setIsUIVisible: (visible: boolean) => void;
}

export const usePromptsStore = create<PromptsStore>()(
  devtools(
    (set) => ({
      activeView: 'create',
      sidebarCollapsed: getStoredSidebarCollapsed(),
      isSidebarInitialized: false,
      isUIVisible: true,

      setActiveView: (view) => set({ activeView: view }),
      setSidebarCollapsed: (collapsed) => {
        setStoredSidebarCollapsed(collapsed);
        set({ sidebarCollapsed: collapsed });
      },
      setSidebarInitialized: (initialized) => set({ isSidebarInitialized: initialized }),
      toggleSidebar: () => set((state) => {
        const next = !state.sidebarCollapsed;
        setStoredSidebarCollapsed(next);
        return { sidebarCollapsed: next };
      }),
      setIsUIVisible: (visible) => set({ isUIVisible: visible }),
    }),
    { name: 'prompts-store' }
  )
);
